import StylizedMaterialReactTable from './HOClevel'

export default StylizedMaterialReactTable
